module.exports = __webpack_public_path__ + "19fcf7a7b378494f1ae87dccb7cc512e.pdf";